<template>
    <div class="login">
        <div class="form">
            <login-input v-model="form.merchantAccount" placeholder="请输入商户号">商户号</login-input>
            <login-input v-model="form.account"  placeholder="请输入账号">
                账号
                <template #suffix>
                    <el-button class="transfer-btn" v-if="type === 'login'" @click="showTransferDialog" :disabled="!form.account" size="mini">
                        <label>转账</label>
                    </el-button>
                </template>
            </login-input>
            <login-input type="password" v-model="form.password"  placeholder="请输入密码">密码</login-input>
            <login-input v-model="form.currencyType" v-if="type !== 'login'" placeholder="请输入货币类型(1 - 17)">货币</login-input>
            <el-select class="login-input" v-if="type === 'login'" v-model="form.currentHallType">
                <el-option
                    v-for="(item, key) in currentHallTypes"
                    :key="key"
                    :label="item.label"
                    :value="item.value"
                />
            </el-select>
            <el-select class="login-input" v-if="type === 'login'" v-model="form.lang">
                <el-option
                    v-for="(item, key) in langs"
                    :key="key"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                />
            </el-select>
            <el-select class="login-input" v-if="type === 'login' && form.currentHallType == 1" v-model="form.colorTheme">
                <el-option
                    v-for="(item, key) in themeList"
                    :key="key"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                />
            </el-select>
            <div class="login-radio" v-if="type === 'login'">
                <click-radio v-model="record">
                    记住登陆信息
                </click-radio>
            </div>
            <el-button class="login-btn mt-91px" v-if="type === 'register'" type="primary" @click="register">注册</el-button>
            <div class="btn">
                <el-button class="login-btn" v-if="type === 'login'" type="primary" @click="() => login(1)">
                <img :src="require('../assets/img/icon-pc.png')"/>&nbsp;&nbsp;
                <span>进入WEB端</span>
            </el-button>
            <el-button class="login-btn mt-25px" v-if="type === 'login'" type="primary" @click="() => login(2)">
                <img :src="require('../assets/img/icon-h5.png')"/>&nbsp;&nbsp;
                <span>进入H5端</span>
            </el-button>
            </div>
            <el-dialog title="转账" width="480px" :visible.sync="transferDialogVisible">
                <div class="dialog-content">
                    <div>
                        <label>
                            转入金额：
                        </label>
                        <login-input v-model="transferAmount" class="content"></login-input>
                    </div>
                    <div class="balance-tip">
                        <label></label>
                        <span class="content">当前余额： {{balance}}</span>
                    </div>
                    <span class="dialog-footer">
                        <el-button size="mini" @click="transferDialogVisible = false">取消</el-button>
                        <el-button size="mini" type="primary" @click="transfer">转账</el-button>
                    </span>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import LoginInput from "./loginInput";
    import {register, login, transfer, balanceQuery} from "../api/login";
    import {stringify} from "qs";
    import {sign} from "../api/sign";
    import ClickRadio from "./clickRadio";

    export default {
        name: "login",
        components: {ClickRadio, LoginInput},
        props: {
            type: String,
        },
        data() {
            return {
                form: {
                    merchantAccount : '',
                    account : '',
                    password : '',
                    currencyType: '1',
                    currentHallType: 1,
                    lang: 1,
                    colorTheme: 1
                },
                transferAmount: '',
                record: true,
                transferDialogVisible: false,
                balance: '查询中...',
                currentHallTypes: [
                    {
                        label: '原版大厅',
                        value: 1,
                    },
                    {
                        label: '万字4D大厅',
                        value: 2,
                    },
                    {
                        label: '越南彩大厅',
                        value: 3,
                    },
                    {
                        label: '泰国彩大厅',
                        value: 4,
                    },
                    {
                        label: '台湾大厅',
                        value: 5,
                    },
                    {
                        label: '韩国大厅',
                        value: 6,
                    },
                ],
                langs: [
                    {
                    label: '中文简体',
                    value: 1,
                    },
                    {
                    label: '中文繁体',
                    value: 2,
                    },
                    {
                    label: '英文',
                    value: 3,
                    },
                    {
                    label: '越南文',
                    value: 4,
                    },
                    {
                    label: '马来语',
                    value: 5,
                    },
                    {
                    label: '泰语',
                    value: 6,
                    },
                    {
                    label: '印尼语',
                    value: 7,
                    // disabled: true
                    },
                    {
                    label: '葡萄牙语',
                    value: 8,
                    },
                    {
                    label: '韩语',
                    value: 10,
                    },
                ],
                themeList: [
                    {label: '日间模式',value: 1},
                    {label: '夜间模式',value: 2}
                ],
            }
        },
        methods: {
            merchantJudge() {
                // if(process.env.VUE_APP_VALID_MERCHANT.split(',').indexOf(this.form.merchantAccount) === -1) {
                //     this.$message({
                //         type: 'error',
                //         message: '没有该key'
                //     })
                //     return false
                // }
                return true
            },
            judge() {
                let errorMsg = {
                    merchantAccount : '请输入商户号',
                    account : '请输入账号',
                    password : '请输入密码',
                }
                let keys = Object.keys(errorMsg)
                let flag = true
                for(let i = 0; i < keys.length; i++) {
                    if(!this.form[keys[i]]) {
                        this.$message({
                            type: 'error',
                            message: errorMsg[keys[i]]
                        })
                        flag = false
                        break
                    }
                }
                return flag
            },
            login(type) {
                if(this.judge() && this.merchantJudge()) {
                    login(stringify({
                        ...sign({
                        member: this.form.account,
                        password:this.form.password,
                        merchant: this.form.merchantAccount,
                        timestamp: new Date() - 0,
                        }),
                        currentHallType: this.form.currentHallType,
                        lang: this.form.lang,
                        colorTheme: this.form.currentHallType == 1?this.form.colorTheme:1,
                    })).then(r => {
                        if(r.sucess) {
                            if(this.record) {
                                localStorage.setItem('loginForm', JSON.stringify({
                                    member: this.form.account,
                                    password:this.form.password,
                                    merchant: this.form.merchantAccount,
                                    currentHallType: this.form.currentHallType,
                                    lang: this.form.lang,
                                    colorTheme: this.form.colorTheme
                                }))
                            } else {
                                localStorage.clear()
                            }
                            // const baseUrl = type === 1 ? process.env.VUE_APP_WEB_ADDRESS : process.env.VUE_APP_H5_ADDRESS
                            location.href = type === 1 ? r.data.pc : r.data.h5
                        } else {
                            this.$message({
                                type: 'error',
                                message: r.msg
                            })
                        }
                    })
                }
            },
            register() {
                if(this.judge() && this.merchantJudge()) {
                    register(
                        {
                            ...sign({
                            member: this.form.account,
                            memberType: 3, // 1 正式账号，3 测试账号
                            password: this.form.password,
                            merchant: this.form.merchantAccount,
                            doubleList: '[]',
                            normalList: '[]',
                            timestamp: new Date() - 0,
                        }),
                        
                        currencyType: parseInt(this.form.currencyType),
                    }
                    ).then(r => {
                        if (r.sucess) {
                            this.$message({
                                type: 'success',
                                message: '注册成功'
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: r.msg
                            })
                        }
                    })
                }
            },
            balanceQuery() {
                balanceQuery(sign({
                    member: this.form.account,
                    merchant: this.form.merchantAccount,
                    timestamp: new Date() - 0,
                })).then(r => {
                    if(r.sucess) {
                        this.balance = r.data.amount
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.msg
                        })
                    }
                })
            },
            showTransferDialog() {
                if(!this.merchantJudge()) {
                    return
                }
                this.transferDialogVisible = true
                this.balanceQuery()
            },
            transfer() {
                if(!this.transferAmount) {
                    this.$message({
                        type: 'error',
                        message: '请输入转账金额',
                    })
                    return
                }
                if(parseFloat(this.transferAmount) > 10000000000000) {
                    this.$message({
                        type: 'error',
                        message: '转账金额过大',
                    })
                    return
                }
                if(parseFloat(this.transferAmount).toString() != this.transferAmount) {
                    this.$message({
                        type: 'error',
                        message: '转账金额格式有误',
                    })
                    return
                }
                transfer(sign({
                    member: this.form.account,
                    merchantAccount: this.form.merchantAccount,
                    transferType: 1,
                    amount: parseFloat(this.transferAmount),
                    notifyId: Math.random().toString(36).substr(2),
                    timestamp: new Date() - 0,
                })).then(r => {
                    if(r.sucess) {
                        this.balanceQuery()
                        this.$message({
                            type: 'success',
                            message: '转账成功'
                        })
                        this.transferAmount = ''
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.msg
                        })
                    }
                })
            }
        },
        created() {
            const loginForm = localStorage.getItem('loginForm')
            if(loginForm && this.type === 'login') {
                let form = JSON.parse(loginForm)
                this.form.account = form.member
                this.form.password = form.password
                this.form.merchantAccount = form.merchant
                this.form.currentHallType = form.currentHallType || 1
                this.form.lang = form.lang || 1,
                this.form.colorTheme = form.colorTheme || 1
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../styles/element-variables";
    @media screen and (max-width: $--media-max-width){
        .login {
            .login-radio {
                text-align: left;
                margin-top: 0.016rem;
                margin-bottom: 0.1913rem;
            }
            .form {
                width: 1.8667rem;
                margin-top: 0.1533rem;
            }
            .login-btn {
                height: 0.2867rem;
                padding: 0!important;
                img {
                    height: 0.12rem;
                }
                span {
                    font-size: 0.12rem;
                }
            }
            .transfer-btn {
                height: 0.22rem;
                label {
                    font-size: 0.1067rem;
                }
            }
            .mt-25px {
                // margin-top: 0.1067rem;
            }
            .mt-91px {
                margin-top: 0.1067rem;
            }
            .dialog-content {
                font-size: 0.1067rem;
                label {
                    width: 0.5333rem;
                }
                .content {
                    width: 1.2447rem;
                }
                .balance-tip {
                    font-size: 0.0933rem;
                }
                .dialog-footer {
                    width: 100%;
                    margin-top: 0.2353rem;
                    margin-bottom: 0.282rem;
                    .el-button{
                        width: 0.5333rem;
                        height: 0.2667rem;
                        margin-left: 0.1333rem;
                        margin-right: 0.1333rem;
                    }
                }
            }
        }
    }
    .mt-91px {
        margin-top: 92px;
    }
    .login-radio {
        text-align: left;
        margin-top: 3px;
        margin-bottom: 20px;
    }
    .login {
        text-align: center;
        display: inline-block;
        position: relative;
    }
    .form {
        width: 480px;
        margin-top: 40px;
        margin-left: auto;
        margin-right: auto;
    }
    .login-btn {
        height: 65px;
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 4px 4px 0 rgba(128, 100, 190, 0.3);
    }
    .transfer-btn {
        height: 50px;
        width: 100%;
        border-radius: 8px;
        background-color: $--color-primary;
        color: white;
        label {
            font-size: 18px;
            cursor: pointer;
        }
    }
    .transfer-btn:hover {
        background-color: $--color-primary;
        color: white;
    }
    .mt-25px {
        // margin-top: 25px;
    }
    .btn{
        display: flex;
    }
    .dialog-content {
        color: #9f9ed2;
        font-size: 22px;
        white-space: nowrap;
        label {
            width: 120px;
            display: inline-block;
        }
        .content {
            width: 280px;
            display: inline-block;
            text-align: left;
        }
        .balance-tip {
            font-size: 20px;
        }
        .dialog-footer {
            text-align: center;
            display: inline-block;
            width: 100%;
            margin-top: 54px;
            margin-bottom: 43px;
            .el-button{
                width: 120px;
                height: 60px;
                margin-left: 30px;
                margin-right: 30px;
            }
        }
    }
</style>
